import * as yup from "yup";
import { LlmImageStyle } from "@towersystems/roam-common/lib/generated-types";

export const defaultFormValues = {
  description: "",
  style: [LlmImageStyle.FLAT_DESIGN],
  colorScheme: "orange",
  backgroundColor: "#fff",
  generatedBase64Images: null,
};

export const schema = yup.object().shape({
  description: yup.string().required("Description is required"),
  style: yup
    .array()
    .of(yup.mixed<LlmImageStyle>().oneOf(Object.values(LlmImageStyle)))
    .min(1, "At least one style must be selected"),
  colorScheme: yup.string().nullable(),
  backgroundColor: yup.string().nullable(),
  generatedBase64Images: yup.array().of(yup.string()).nullable(),
});
